import React from "react";
import styled from "styled-components";

/**
 * "Trống" có ba nghĩa hoàn toàn khác nhau: đang tải / không có dòng nào / bị lọc
 * mất. Trước đây cả ba hiện y hệt một ô trắng, và đó là nguyên nhân của báo động
 * giả "hệ thống log đã chết" ngày 2026-08-05 — trong khi log vẫn ghi 25.000
 * dòng/ngày. Không bao giờ để một ô trống câm.
 *
 * Nợ Task 5 xử ở đây (7B): bảng màu đổi sang đúng bộ mà TimeRangePicker.tsx và
 * phần style nội tuyến của StationPortalLogs.tsx đang dùng (xanh #0f62fe, viền
 * #cbd5e1, chữ #64748b/#0f172a) — trước đó file này tự bịa một bảng màu riêng
 * (#5c7688/#0b2b45/#dfeaf0/#12557f), thành ra một màn hình có ba bảng màu.
 * Chỉ đổi giá trị màu — không đổi cấu trúc hay câu chữ.
 */
const Wrap = styled.div`
	padding: 48px 24px;
	text-align: center;
	color: #64748b;
	font-size: 14px;
	line-height: 1.6;
`;

const Title = styled.div`
	font-weight: 600;
	color: #0f172a;
	margin-bottom: 6px;
`;

const ClearButton = styled.button`
	margin-top: 12px;
	font: inherit;
	font-size: 13px;
	font-weight: 600;
	cursor: pointer;
	padding: 7px 14px;
	border-radius: 7px;
	border: 1px solid #cbd5e1;
	background: #fff;
	color: #0f62fe;
`;

export default function EmptyState(props: {
	loading: boolean;
	activeFilterCount: number;
	rangeLabel: string;
	onClearFilters: () => void;
}) {
	if (props.loading) {
		return (
			<Wrap>
				<Title>Đang tải…</Title>
				<div>Đang lấy log trong {props.rangeLabel}.</div>
			</Wrap>
		);
	}

	if (props.activeFilterCount > 0) {
		return (
			<Wrap>
				<Title>Không dòng nào khớp bộ lọc.</Title>
				<div>
					Đang bật {props.activeFilterCount} ô lọc trong {props.rangeLabel}.
				</div>
				<ClearButton
					type="button"
					onClick={props.onClearFilters}>
					Xoá bộ lọc
				</ClearButton>
			</Wrap>
		);
	}

	return (
		<Wrap>
			<Title>Không có log nào trong {props.rangeLabel}.</Title>
			<div>Thử nới khoảng thời gian rộng hơn.</div>
		</Wrap>
	);
}
